(() => {
  if (window.__pawcareBundlerOffersBound) return;
  window.__pawcareBundlerOffersBound = true;

  const offerBlocks = () => document.querySelectorAll('[data-pc-bundler-offers]');
  const createOfferBlock = () => {
    const offer = document.createElement('aside');
    offer.className = 'pc-bundler-offers';
    offer.dataset.pcBundlerOffers = '';
    offer.hidden = true;
    offer.setAttribute('aria-label', 'Stock-up savings');
    offer.innerHTML = `
      <div class="pc-bundler-offers__intro">
        <p class="pc-bundler-offers__eyebrow">Stock-up savings</p>
        <h2 class="pc-bundler-offers__heading">Choose the amount that keeps the routine easy.</h2>
        <p class="pc-bundler-offers__body">Choose an offer below. Your chosen amount and savings stay in sync with your cart.</p>
      </div>
      <div class="pc-bundler-offers__frame">
        <div class="bundler-quantity-breaks" data-pc-bundler-target></div>
      </div>
      <p class="pc-bundler-offers__note"><span aria-hidden="true">✓</span>Your selected savings are applied automatically.</p>
    `;
    return offer;
  };

  const ensureOfferBlocks = () => {
    document.querySelectorAll('[data-testid="product-information"]').forEach((productInformation) => {
      if (productInformation.querySelector('[data-pc-bundler-offers]')) return;

      const purchaseControls = productInformation.querySelector('.buy-buttons-block');
      if (!purchaseControls) return;

      purchaseControls.before(createOfferBlock());
    });
  };

  const sync = () => {
    offerBlocks().forEach((offer) => {
      const hasQuantityBreaks = offer.querySelector('.bndlr-radio-container, .bndlr-break, .bndlr-volume');
      const isThemeEditor = offer.dataset.pcBundlerDesignMode === 'true';
      if (isThemeEditor && !hasQuantityBreaks) return;
      offer.hidden = !hasQuantityBreaks;
      offer.toggleAttribute('data-pc-bundler-ready', Boolean(hasQuantityBreaks));
    });
  };

  const observe = () => {
    ensureOfferBlocks();
    sync();
    new MutationObserver(sync).observe(document.documentElement, { childList: true, subtree: true });
    document.addEventListener('bundler:loaded', sync);
    document.addEventListener('bundler:bundle_widget_created', sync);
    window.setTimeout(sync, 750);
    window.setTimeout(sync, 2500);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observe, { once: true });
  } else {
    observe();
  }
})();
